import { render, staticRenderFns } from "./GalleryWhite.vue?vue&type=template&id=2433d66a&"
import script from "./GalleryWhite.vue?vue&type=script&lang=js&"
export * from "./GalleryWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports